import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

type ModalState = {
	modal: {
		team: {
			isOpen: boolean;
			isSubmitting: boolean;
			step: number;
			isSaveBtnDisabled: boolean;
		};
	};
};

type ModalActions = {
	setIsTeamModalOpen: (isOpen: ModalState['modal']['team']['isOpen']) => void;
	setIsTeamSubmitting: (isOpen: ModalState['modal']['team']['isSubmitting']) => void;
	setStep: (step: ModalState['modal']['team']['step']) => void;
	setIsSaveBtnDisabled: (isSaveBtnDisabled: ModalState['modal']['team']['isSaveBtnDisabled']) => void;
};

export type ModalSlice = ModalState & ModalActions;

const modalInitialState: ModalState = {
	modal: {
		team: {
			isOpen: false,
			isSubmitting: false,
			step: 0,
			isSaveBtnDisabled: true,
		},
	},
};

export function modalSlice(set: NamedSet<ZustandStore>): ModalSlice {
	return {
		...modalInitialState,
		setIsTeamModalOpen(isOpen: ModalState['modal']['team']['isOpen']): void {
			set(
				(state: ModalState) => {
					state.modal.team.isOpen = isOpen;
					return state;
				},
				false,
				'[setIsTeamModalOpen]',
			);
		},
		setIsTeamSubmitting(isSubmitting: ModalState['modal']['team']['isSubmitting']): void {
			set(
				(state: ModalState) => {
					state.modal.team.isSubmitting = isSubmitting;
					return state;
				},
				false,
				'[setIsTeamSubmitting]',
			);
		},
		setStep(step: ModalState['modal']['team']['step']): void {
			set(
				(state: ModalState) => {
					state.modal.team.step = step;
					return state;
				},
				false,
				'[setStep]',
			);
		},
		setIsSaveBtnDisabled(isSaveBtnDisabled: ModalState['modal']['team']['isSaveBtnDisabled']): void {
			set(
				(state: ModalState) => {
					state.modal.team.isSaveBtnDisabled = isSaveBtnDisabled;
					return state;
				},
				false,
				'[setIsSaveBtnDisabled]',
			);
		},
	};
}
